const Car = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="90"
      viewBox="0 0 91 90"
      fill="none"
      {...props}
    >
      <path
        d="M34.957 67.8652H60.347"
        stroke="#333333"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M18 30H41"
        stroke="#B38A5A"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M66 30V42.9376C66 45.1812 67.8188 47 70.0624 47H84"
        stroke="#B38A5A"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M56 67.0103V20.5C56 19.3954 55.1046 18.5 54 18.5H8C6.89543 18.5 6 19.3954 6 20.5V66C6 67.1046 6.89543 68 8 68H18.0082"
        stroke="#333333"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle
        cx="69.9861"
        cy="68.283"
        r="7.64818"
        stroke="#333333"
        strokeWidth="4"
      />
      <circle
        cx="26.322"
        cy="68.283"
        r="7.64818"
        stroke="#333333"
        strokeWidth="4"
      />
      <path
        d="M56 30.2871H72.6488C74.1393 30.2871 75.5102 31.1034 76.2204 32.4139L86.2564 50.9331C86.5785 51.5274 86.7472 52.1927 86.7472 52.8687V63.8019C86.7472 66.0455 84.9284 67.8643 82.6848 67.8643H78.1146M54.248 67.8643C54.248 67.8643 58.1843 67.8643 61.3572 67.8643"
        stroke="#333333"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Car
